// extracted by css-extract-rspack-plugin
module.exports =  {"participants":"RoomCard__participants___u0AQr","participant":"RoomCard__participant___sbl9P","buttonGroup":"RoomCard__buttonGroup___MvMPP"};